import { getItemUser, type ItemFieldEntry } from '@cheqroom/api';

import type { InfoField } from '../../../../Info/fields/Fields.types';
import { resolveSystemFields, type SystemFieldReader } from '../../../../Info/fields/utils';
import type { ItemInfoItem } from '../../../ItemInfo.context';

/** `custody` is the "User" field: the custodian, else the current booking's customer — as the column. */
const itemFieldReader: SystemFieldReader<ItemInfoItem> = {
	readField: (item, id) => (id === 'custody' ? getItemUser(item) : (item as unknown as Record<string, unknown>)[id]),
	hasField: (item, id) => id in item || id === 'custody',
};

export const resolveSystemFieldsFromItem = (item: ItemInfoItem, customFields: ItemFieldEntry[] = []): InfoField[] =>
	resolveSystemFields(item, customFields, itemFieldReader);
